import type { ButtonHTMLAttributes } from "react";
import { cva, type VariantProps } from "class-variance-authority";
import { cn } from "../../lib/cn";

const buttonVariants = cva(
  "inline-flex min-h-9 items-center justify-center gap-2 rounded-md border text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50",
  {
    variants: {
      variant: {
        default: "border-primary bg-primary px-3 text-primary-foreground hover:bg-primary/90",
        secondary: "border-border bg-secondary px-3 text-secondary-foreground hover:bg-accent",
        outline: "border-border bg-background px-3 text-foreground hover:bg-accent",
        ghost: "border-transparent px-2 text-muted-foreground hover:bg-accent hover:text-foreground",
        destructive:
          "border-destructive bg-destructive px-3 text-destructive-foreground hover:bg-destructive/90",
      },
      size: { sm: "h-8 text-xs", default: "h-9", lg: "h-10 px-4", icon: "size-9 p-0" },
    },
    defaultVariants: { variant: "default", size: "default" },
  },
);

export interface ButtonProps
  extends ButtonHTMLAttributes<HTMLButtonElement>,
    VariantProps<typeof buttonVariants> {}

export function Button({ className, variant, size, type = "button", ...props }: ButtonProps) {
  return <button type={type} className={cn(buttonVariants({ variant, size }), className)} {...props} />;
}